import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_Scope = _resolveComponent("Scope")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "default_card large mx-0 my-2 pa-2 fill-height sticky-card",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "py-1",
            style: {"flex-wrap":"nowrap"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "d-flex justify-start align-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_back, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'company-scopes' })), ["stop"]))
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "d-flex justify-end align-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    class: "ml-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateScope())),
                    size: "small",
                    disabled: _ctx.validDisabled
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.patternId ? "Modifier" : "Créer"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "default_card_admin"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_Scope, {
                ref: "refScope",
                modelValue: _ctx.scopeSync,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scopeSync) = $event)),
                id: _ctx.scopeId,
                "onUpdate:id": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scopeId) = $event)),
                onValidName: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validName = $event))
              }, null, 8, ["modelValue", "id"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}